import { useFlags } from 'launchdarkly-react-client-sdk';
import useIntl from 'hooks/useIntl';
import messages from '../../messages';
import {
  RECERT_TYPE_MESSAGE_KEYS,
  RECERT_TYPE_OPTIONS_BY_PROGRAM,
} from './constants';

export const useRecertType = ({ program, recertTypes, onChange }) => {
  const intl = useIntl();
  const { recertApplicationRevamp } = useFlags();

  const options = (RECERT_TYPE_OPTIONS_BY_PROGRAM[program] ?? []).map(
    (value) => ({
      value,
      text: intl.formatMessage(messages[RECERT_TYPE_MESSAGE_KEYS[value]]),
    }),
  );

  const handleChange = (value) => {
    onChange({
      target: {
        name: 'setup.recertTypes',
        value: { ...recertTypes, [program]: value },
      },
    });
  };

  return {
    isEnabled: Boolean(recertApplicationRevamp),
    options,
    handleChange,
  };
};
